// src/pages/DistributorManagement.jsx
import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { PlusCircle, ArrowLeft, DollarSign } from 'lucide-react';
import DistributorList from '../components/partners/DistributorList';
import DistributorForm from '../components/partners/DistributorForm';
import ProductPriceForm from '../components/partners/ProductPriceForm';
import useAuth from '../hooks/useAuth';
import DistributorDetails from '../components/partners/DistributorDetails';
import { useLocation } from 'react-router-dom';

const DistributorManagement = () => {
    const { isAdmin, isManager } = useAuth();
    const [view, setView] = useState('list');
    const [selectedDistributorId, setSelectedDistributorId] = useState(null);

    const canModify = isAdmin || isManager;

    const handleAddDistributor = () => {
        setSelectedDistributorId(null);
        setView('form');
    };

    const handleEditDistributor = (distributorId) => {
        setSelectedDistributorId(distributorId);
        setView('form');
    };

    const handleViewDistributor = (distributorId) => {
        setSelectedDistributorId(distributorId);
        setView('details');
    };

    const handleManagePrices = (distributorId) => {
        setSelectedDistributorId(distributorId);
        setView('prices');
    };

    const handleCancel = () => {
        setView('list');
        setSelectedDistributorId(null);
    };

    const location = useLocation();
    useEffect(() => {
        handleCancel(); // remet view='list' + selectedProductId=null
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.key]);

    const handleSuccess = () => {
        setView('list');
        setSelectedDistributorId(null);
    };

    return (
        <Container fluid>
            <div className="d-flex justify-content-between align-items-center mb-4">
                {view === 'list' ? (
                    <h1 className="h3">Gestion des distributeurs</h1>
                ) : (
                    <div className="d-flex align-items-center">
                        <Button
                            variant="link"
                            className="p-0 me-2"
                            onClick={handleCancel}
                        >
                            <ArrowLeft size={20} />
                        </Button>
                        <h1 className="h3 mb-0">
                            {view === 'form'
                                ? (selectedDistributorId ? 'Modifier un distributeur' : 'Ajouter un distributeur')
                                : view === 'prices'
                                    ? 'Gestion des prix spécifiques'
                                    : 'Détails du distributeur'
                            }
                        </h1>
                    </div>
                )}

                {canModify && view === 'list' && (
                    <Button
                        variant="primary"
                        onClick={handleAddDistributor}
                    >
                        <PlusCircle size={16} className="me-1" />
                        Nouveau distributeur
                    </Button>
                )}
            </div>

            {view === 'list' && (
                <DistributorList
                    onAddDistributor={handleAddDistributor}
                    onEditDistributor={handleEditDistributor}
                    onViewDistributor={handleViewDistributor}
                    onManagePrices={handleManagePrices}
                />
            )}

            {view === 'form' && (
                <DistributorForm
                    distributorId={selectedDistributorId}
                    onCancel={handleCancel}
                    onSuccess={handleSuccess}
                />
            )}

            {view === 'details' && (
                <DistributorDetails
                    distributorId={selectedDistributorId}
                    onEdit={handleEditDistributor}
                    onManagePrices={handleManagePrices}
                    onBack={handleCancel}
                />
            )}

            {view === 'prices' && (
                <ProductPriceForm
                    distributorId={selectedDistributorId}
                    onCancel={handleCancel}
                    onSuccess={handleSuccess}
                />
            )}
        </Container>
    );
};

export default DistributorManagement;